import { simpleAlert } from "components/CommonLib/CommonLib";
import { collection, deleteDoc, doc, getDocs, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { db } from "../../firebase";

const HistoryModal = ({ isOpen, onClose, onLoadHistory }) => {
  const storesDispatch = useDispatch();
  const [historyList, setHistoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchHistory = async () => {
    try {
      setIsLoading(true);
      const branch = sessionStorage.getItem("branch");
      const historyRef = collection(db, "deploy", "estimate", "history");
      const q = query(historyRef, where("branch_name", "==", branch));
      const snapshot = await getDocs(q);

      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      list.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setHistoryList(list);
    } catch (err) {
      console.error("히스토리 로드 실패:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteHistory = async (historyId) => {
    try {
      await deleteDoc(doc(db, "deploy", "estimate", "history", historyId));
      setHistoryList((prev) => prev.filter((h) => h.id !== historyId));
    } catch (err) {
      console.error("히스토리 삭제 실패:", err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchHistory();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={styles.title}>구매요청 이력</h2>

        {isLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>로딩 중...</div>
        ) : historyList.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>이력이 없습니다</div>
        ) : (
          <div style={styles.list}>
            {historyList.map((history) => (
              <div key={history.id} style={styles.historyItem}>
                <div style={styles.historyHeader}>
                  <span style={styles.date}>{history.created_at}</span>
                  <div style={styles.historyHeaderRight}>
                    <span style={styles.itemCount}>{history.items.length}개 품목</span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onLoadHistory(history);
                        onClose();
                      }}
                      style={{
                        padding: "4px 8px",
                        backgroundColor: "#10134F",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      🛒 불러오기
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        simpleAlert(
                          storesDispatch,
                          "알림",
                          "이 이력을 삭제하시겠습니까?",
                          false,
                          () => {},
                          () => {
                            deleteHistory(history.id);
                          },
                        );
                      }}
                      style={styles.deleteButton}
                    >
                      삭제
                    </button>
                  </div>
                </div>
                <div style={styles.historyBody}>
                  <div style={styles.itemNames}>
                    {history.items.slice(0, 3).map((item, idx) => (
                      <span key={idx}>
                        {item.name} x{item.quantity}
                        {idx < Math.min(2, history.items.length - 1) && ", "}
                      </span>
                    ))}
                    {history.items.length > 3 && ` 외 ${history.items.length - 3}개`}
                  </div>
                  <div style={styles.totalAmount}>총 {history.total_amount.toLocaleString()}원</div>
                </div>
              </div>
            ))}
          </div>
        )}

        <button onClick={onClose} style={styles.closeButton}>
          닫기
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "24px",
    width: "600px",
  },
  title: {
    margin: "0 0 20px 0",
    fontSize: "20px",
    fontWeight: "600",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "70vh",
    overflowY: "auto",
    gap: "12px",
  },
  historyItem: {
    padding: "10px 14px",
    border: "1px solid #10134F",
    borderRadius: "8px",
    transition: "all 0.2s",
    backgroundColor: "#fff",
  },
  historyHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  historyHeaderRight: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  date: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
  },
  itemCount: {
    fontSize: "13px",
    color: "#666",
  },
  historyBody: {
    display: "flex",
    // flexDirection: "",
    justifyContent: "space-between",
    gap: "3px",
  },
  itemNames: {
    fontSize: "13px",
    color: "#666",
  },
  totalAmount: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#10134F",
  },
  closeButton: {
    width: "100%",
    padding: "12px",
    marginTop: "16px",
    borderRadius: "8px",
    border: "1px solid #aaa",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    color: "#10134F",
  },
  deleteButton: {
    padding: "4px 8px",
    backgroundColor: "#fff",
    color: "#10134F",
    border: "1px solid #10134F",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600",
  },
};

export default HistoryModal;
